// Every tab of this browser looks at the same server-side timer, so when one
// of them starts, stops or discards it the others are instantly wrong. A
// BroadcastChannel tells them right away instead of making them wait for the
// next resync. Browsers without it (older Safari) simply don't get the
// message and fall back to the periodic resync, so it stays optional.
const CHANNEL_NAME = "cwclock-running";

const supported = () => typeof BroadcastChannel !== "undefined";

// One channel for posting, opened on first use so importing this module costs
// nothing in environments that have no BroadcastChannel (tests, SSR).
let poster = null;

export const notifyRunningChanged = () => {
  if (!supported()) return;
  if (!poster) poster = new BroadcastChannel(CHANNEL_NAME);
  poster.postMessage({ type: "running-changed" });
};

// Listens for the other tabs' notifications - a tab never hears its own
// posts. Returns the unsubscribe, so callers can always call it blindly.
export const subscribeRunningChanged = (handler) => {
  if (!supported()) return () => {};
  const channel = new BroadcastChannel(CHANNEL_NAME);
  channel.onmessage = () => handler();
  return () => channel.close();
};
